module.exports = __webpack_public_path__ + "static/media/15b.35f41ff8.jpg";